import { render } from "./BuyAccidentChildrenComponent.vue?vue&type=template&id=586a00fc&ts=true"
import script from "./BuyAccidentChildrenComponent?vue&type=script&lang=ts"
export * from "./BuyAccidentChildrenComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__